export enum GTMEvent {
  PUSH_PARAMS = 'GTM event to GA',
  ENTER_EMAIL = 'enter_email',
}

export enum GTMEventLabel {
  START = 'onboarding - start',
  CLICK_TO_SEND_EMAIL = 'onboarding - click to send mail',
  CONFIRM_SCREEN = 'onboarding - confirm screen',
  SUBMIT_APPLICATION = 'onboarding - submit application',
}
